export default "__VITE_ASSET__Cilx73dX__"